import { GridColDef } from "@mui/x-data-grid";

export const resignationLettersTableColumns: GridColDef[] = [
  { field: "employeeFirstName", headerName: "First Name", width: 180 },
  { field: "employeeLastName", headerName: "Last Name", width: 180 },
  {
    field: "lastDateOfWork",
    headerName: "Last Date Of Work",
    width: 180,
    valueFormatter: (value) =>
      value ? new Date(value as string).toLocaleDateString() : "",
  },
  { field: "reasonOfTermination", headerName: "Reason", width: 320 },
  { field: "comment", headerName: "Comment", width: 320 },
];
